import { EmojiSadIcon } from "@heroicons/react/outline";
import { CardsGrid } from "../ui/Cards/Card";
import { CardSkeleton } from "../ui/Cards/CardSkeleton";
import { DatasetGroup } from "@/queries/datasets/types";
import { DatasetCardWithProgress } from "./DatasetCardWithProgress";

export const DatasetPageContent = ({
  datasetGroupList,
  isLoading,
}: {
  datasetGroupList: DatasetGroup[];
  isLoading: boolean;
}) => {
  if (isLoading) {
    return <CardSkeleton showBody={false} />;
  }

  if (datasetGroupList.length === 0) {
    return (
      <div className="flex h-full flex-col items-center justify-center">
        <div className="pt-8 text-2xl text-gray-500">
          No datasets found{" "}
          <EmojiSadIcon className="-mt-1 inline h-6 w-auto text-gray-500" />
        </div>
      </div>
    );
  }

  return (
    <CardsGrid>
      {datasetGroupList.map((datasetGroup) => (
        <DatasetCardWithProgress
          key={datasetGroup.id}
          datasetGroup={datasetGroup}
        />
      ))}
    </CardsGrid>
  );
};
